"use client";
import { useTranslation } from "react-i18next";
import "./Hero.css";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const Hero = () => {
  const { lang } = useParams();
  const [showScrollButton, setShowScrollButton] = useState(true);
  const { t } = useTranslation("global");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  // Hide scroll button when user scrolls down
  useEffect(() => {
    const handleScroll = () => {
      // Hide button when scrolled more than 100px
      if (window.scrollY > 100) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="hero" aria-label="Main introduction">
      <div className="container">
        <header className="headings">
          <h1>
            {t("hero.heading1")}
            <h1 style={{ color: "rgba(181,181,181,1)", display: "block" }}>
              {t("hero.heading2")}
            </h1>
          </h1>
        </header>
        <div className="hero-body">
          {/* <p>{t("hero.description")}</p> */}
          <div className="hero-buttons">
            <Link
              to={`/${lang}/OurServices`}
              onClick={scrollToTop}
              className="service-link"
              aria-label="Learn about our services"
            >
              <button className="button1">{t("hero.button1")}</button>
            </Link>
            <Link
              to={`/${lang}/ContactUs`}
              onClick={scrollToTop}
              className="contact-link"
              aria-label="Contact Virtue for business solutions"
            >
              <button className="button2">{t("hero.button2")}</button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator - only shown when at the top */}
      {showScrollButton && (
        <div
          className="scroll-indicator"
          onClick={scrollDown}
          aria-label="Scroll down for more content"
        >
          <span>Scroll Down</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M7 13l5 5 5-5"></path>
            <path d="M7 7l5 5 5-5"></path>
          </svg>
        </div>
      )}
    </section>
  );
};

export default Hero;
